module.exports = __webpack_public_path__ + "img/logo-tp.8be0da35.png";